import { useRef, useState, useCallback } from "react";

// Hook anti-spam: honeypot + time-trap (invisible para usuarios reales).
export function useAntiSpam() {
  const loadedAt = useRef(Date.now());
  const [honeypot, setHoneypot] = useState("");

  const getFields = useCallback(
    () => ({ website: honeypot, elapsed_ms: Date.now() - loadedAt.current }),
    [honeypot]
  );

  return { honeypot, setHoneypot, getFields };
}

// Campo trampa oculto: solo los bots lo rellenan.
export const Honeypot = ({ value, onChange }) => (
  <div
    aria-hidden="true"
    style={{ position: "absolute", left: "-9999px", top: "-9999px", height: 0, width: 0, overflow: "hidden" }}
  >
    <label>
      No completar este campo
      <input
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  </div>
);
